var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M19.9484 37.1667C29.1534 37.1667 36.6151 29.705 36.6151 20.5C36.6151 11.295 29.1534 3.83334 19.9484 3.83334C10.7434 3.83334 3.28174 11.295 3.28174 20.5C3.28174 29.705 10.7434 37.1667 19.9484 37.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.9501 17.5517L20.1168 14.7683C18.9168 14.0683 17.4668 14.0683 16.2668 14.7683C15.0668 15.4683 14.3501 16.7017 14.3501 18.1017V23.685C14.3501 25.0683 15.0668 26.3183 16.2668 27.0183C16.8487 27.3573 17.51 27.5358 18.1834 27.5358C18.8568 27.5358 19.5182 27.3573 20.1001 27.0183L24.9334 24.235C26.1334 23.535 26.8501 22.3017 26.8501 20.9017C26.8834 19.5017 26.1668 18.2517 24.9501 17.5517Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f63f0b049e2297c07515b79e09e5069f.svg";
export { ForwardRef as ReactComponent };